import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="scroll-to"
// Scrolls to a target element (by selector) when the action fires.
// If the element is not yet in the DOM (e.g. inside a lazy turbo frame),
// waits for turbo:frame-load and retries.
export default class extends Controller {
  static values = {
    target: { type: String, default: "" },
    offset: { type: Number, default: 0 }
  }

  scroll(event) {
    event.preventDefault()
    this._scrollToTarget()
  }

  _scrollToTarget() {
    const selector = this.targetValue || this.element.getAttribute("href")
    if (!selector) return

    const el = document.querySelector(selector)
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - this.offsetValue
      window.scrollTo({ top, behavior: "smooth" })
      el.focus({ preventScroll: true })
    } else {
      this._waitForFrame(selector)
    }
  }

  _waitForFrame(selector) {
    const handler = (e) => {
      const el = document.querySelector(selector)
      if (el) {
        document.removeEventListener("turbo:frame-load", handler)
        const top = el.getBoundingClientRect().top + window.scrollY - this.offsetValue
        window.scrollTo({ top, behavior: "smooth" })
        el.focus({ preventScroll: true })
      }
    }
    document.addEventListener("turbo:frame-load", handler)
  }
}
